//should be v1 since a lot of functionality depends on exact string literals returned by this package
import UAParser from 'ua-parser-js-v1';

const parser = new UAParser();
const browser = parser.getBrowser();
const device = parser.getDevice();
const os = parser.getOS();

const { VUE_APP_IS_PRODUCTION } = process.env;
if (!VUE_APP_IS_PRODUCTION) {
  console.log('device', device);
  console.table({
    os: os.name,
    browser: browser.name,
    vendor: device.vendor,
    type: device.type,
  });

  console.log('browser.name', browser.name);
}

const isMacOS = os.name === 'Mac OS';
const isIOS = device.vendor === 'Apple' && (device.type === 'tablet' || device.type === 'mobile');
const isOtherMobile = device.vendor !== 'Apple' && (device.type === 'tablet' || device.type === 'mobile');
const isSafari = browser.name === 'Safari' || browser.name === 'Mobile Safari';
const isChrome = browser.name === 'Chrome' || browser.name === 'Chrome WebView' || browser.name === 'Electron';

const unsupportedMacOs = isMacOS && !isSafari && !isChrome;
const unsupportedIOS = isIOS && !isSafari && !isChrome;
const unsupportedMobile = isOtherMobile && !isChrome;
const unsupportedOther = !isOtherMobile && !isIOS && !isMacOS && !isChrome;

const { VUE_APP_IS_CORDOVA } = process.env;

export default () => {
  return !VUE_APP_IS_CORDOVA && (unsupportedIOS || unsupportedMobile || unsupportedMacOs || unsupportedOther);
};

export { unsupportedIOS, unsupportedMobile, unsupportedMacOs, unsupportedOther, browser, os };
